import { api } from "./api";
import { uid } from "./storage";

let landed = false;

function sessionId(): string {
  try {
    let id = sessionStorage.getItem("dither.sid");
    if (!id) {
      id = uid();
      sessionStorage.setItem("dither.sid", id);
    }
    return id;
  } catch {
    return "anon-session";
  }
}

export const normalizePath = (p: string) => p.replace(/^\/g\/[^/]+/, "/g/:id").slice(0, 200) || "/";

export function trackPageview(path: string) {
  const first = !landed;
  landed = true;
  const params = new URLSearchParams(window.location.search);
  api.post("/analytics/pageview", {
    path: normalizePath(path),
    session_id: sessionId(),
    is_landing: first,
    referrer: first ? document.referrer.slice(0, 500) : "",
    utm_source: first ? params.get("utm_source") || undefined : undefined,
    utm_medium: first ? params.get("utm_medium") || undefined : undefined,
  }).catch(() => undefined);
}

export function trackEvent(name: "decision" | "share" | "group_created", data: { kind?: string; category?: string } = {}) {
  api.post("/analytics/event", {
    name, session_id: sessionId(), path: normalizePath(window.location.pathname),
    kind: (data.kind || "").slice(0, 30), category: (data.category || "").slice(0, 40),
  }).catch(() => undefined);
}
